<template>
  <div class="home">
    <div class="list" :loading="tableLoading">
      <List>
        <ListItem v-for="(item, i) in tableData.data" :key='i'>
          <div @click="$router.push('noticeList/details?id=' + item.id)"><span></span>{{ item.name }}</div>
        </ListItem>
      </List>
    </div>
    <Page style="text-align:right" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
    <!-- <Modal v-model="detailShow" @on-cancel="detailShow=false" title="内容">
      <Row style="line-height:3;max-height:600px;overflow:auto">
        <Col span='24'>标题：{{details.name}}</Col>
        <Col span='24' v-html="details.content"></Col>
       <Col span='24'>发布时间：{{details.create_time}}</Col>
      </Row>
      <div slot="footer">
        <Button type="text" size="small" @click="detailShow=false">关闭</Button>
      </div>
    </Modal> -->
  </div>
</template>

<script>
  import indexPage from "../../mixins/indexPage";
  export default {
    components: {},
    mixins: [indexPage],
    data() {
      return {
        searchData: {
        },
        details: {},
        detailShow: false,
        indexUrl: "/app/notice_relation/index",
      };
    },
    activated() { },
    methods: {
      detailc(row) {
        this.detailShow = true
        this.details = row
        console.log(this.details)
      }
    },
  };
</script>

<style lang="less" scoped>
  .home {
    width: 90%;
    margin: 0 auto 10px;
    min-height: 50vh;
    .ivu-card {
      border-radius: 10px;
      margin: 10px 0;
    }
    .list {
      width: 100%;
      margin-bottom: 20px;
      /deep/.ivu-list-items {
        margin-top: 20px;
      }
      .ivu-list-item {
        cursor: pointer;
        span {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background: rgb(255, 196, 2);
          margin-right: 5px;
        }
      }
    }
  }
</style>
